module.exports = __webpack_public_path__ + "static/media/assessment.610018b1.svg";